import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  EXERCISE_GAP_FILL_WITH_HINT,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTION,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS,
  ExerciseGapFillWithHintQuestionOptions,
} from './types';

const DoTestExerciseGapFillWithHint = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import('./components/readonly/DoTestExerciseGapFillWithHint'
    ).then((mod) => mod.DoTestExerciseGapFillWithHint)
  )
);
const DoTestExerciseGapFillWithHintOption = withDynamicBlogEditorPluginHydration({
  canInteract: true,
})(
  dynamicEditorComponent(() =>
    import('./components/readonly/DoTestExerciseGapFillWithHintOption'
    ).then((mod) => mod.DoTestExerciseGapFillWithHintOption)
  )
);
const DoTestExerciseGapFillWithHintOptions = withDynamicBlogEditorPluginHydration({
  canInteract: true,
})(
  dynamicEditorComponent(
    () =>
      import('./components/readonly/DoTestExerciseGapFillWithHintOptions'
      ).then((mod) => mod.DoTestExerciseGapFillWithHintOptions),
    {
      dependsOn: DoTestExerciseGapFillWithHint,
    }
  )
);
const DoTestExerciseGapFillWithHintQuestion = withDynamicBlogEditorPluginHydration({
  canInteract: true,
})(
  dynamicEditorComponent(() =>
    import('./components/readonly/DoTestExerciseGapFillWithHintQuestion'
    ).then((mod) => mod.DoTestExerciseGapFillWithHintQuestion)
  )
);
export const renderReadOnlyElementExerciseGapFillWithHint = (options) => (props) => {
  const { element } = props;

  switch (element.type) {
    case EXERCISE_GAP_FILL_WITH_HINT:
      return <DoTestExerciseGapFillWithHint {...props} {...options} />;

    case EXERCISE_GAP_FILL_WITH_HINT_QUESTION:
      return <DoTestExerciseGapFillWithHintQuestion {...props} {...options} />;

    case EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS:
      return <DoTestExerciseGapFillWithHintOptions {...props} {...options} />;

    case EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTION:
      return <DoTestExerciseGapFillWithHintOption {...props} {...options} />;

    default:
      return undefined;
  }
};

export const ExerciseGapFillWithHintReadOnlyPlugin = (
  options?: ExerciseGapFillWithHintQuestionOptions
): SlatePlugin => ({
  renderElement: (renderProps: RenderElementProps) => {
    return renderReadOnlyElementExerciseGapFillWithHint(options)(renderProps);
  },
});
